var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 2.00113H3.03865C1.36045 2.00113 0 3.36154 0 5.0397V22.9615C0 24.6397 1.36045 26.0001 3.03865 26.0001H20.9609C22.6391 26.0001 23.9996 24.6397 23.9996 22.9615V5.0397C23.9996 3.36154 22.6391 2.00113 20.9609 2.00113Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 1.42517H3.03865C1.36045 1.42517 0 2.78559 0 4.46374V22.3856C0 24.0637 1.36045 25.4241 3.03865 25.4241H20.9609C22.6391 25.4241 23.9996 24.0637 23.9996 22.3856V4.46374C23.9996 2.78559 22.6391 1.42517 20.9609 1.42517Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9613 1.42566H3.03865C2.23279 1.42577 1.45996 1.74594 0.890124 2.31576C0.320291 2.88558 0.000112465 3.65839 0 4.46423L0 22.3848C-7.06126e-08 23.1908 0.320102 23.9638 0.889923 24.5338C1.45974 25.1039 2.23263 25.4243 3.03865 25.4246H18.2031L23.9996 19.3492V4.46423C23.9997 4.06521 23.9212 3.67007 23.7685 3.30139C23.6159 2.93271 23.3921 2.59771 23.11 2.31554C22.8278 2.03336 22.4929 1.80954 22.1242 1.65685C21.7555 1.50416 21.3604 1.4256 20.9613 1.42566Z",
    fill: "#F2F5F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2977 25.1095C18.2998 25.0823 18.3032 25.0556 18.3066 25.0284L18.2031 25.137H3.03865C2.23282 25.1366 1.46012 24.8162 0.890347 24.2464C0.320575 23.6766 0.000337139 22.9038 0 22.098L0 22.3852C-7.06126e-08 23.1912 0.320102 23.9642 0.889923 24.5342C1.45974 25.1043 2.23263 25.4247 3.03865 25.425H18.2031L18.2943 25.3296C18.29 25.2562 18.2912 25.1826 18.2977 25.1095Z",
    fill: "url(#paint2_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M20.9613 1.42566H20.6797C21.0788 1.42555 21.4739 1.50407 21.8427 1.65673C22.2114 1.80939 22.5464 2.03321 22.8286 2.31539C23.1108 2.59757 23.3346 2.93258 23.4873 3.30129C23.6399 3.67 23.7185 4.06517 23.7183 4.46423V19.3492L21.606 21.858L23.9996 19.3492V4.46423C23.9997 4.06521 23.9212 3.67007 23.7685 3.30139C23.6159 2.93271 23.3921 2.59771 23.11 2.31554C22.8278 2.03336 22.4928 1.80954 22.1242 1.65685C21.7555 1.50416 21.3604 1.4256 20.9613 1.42566Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.158634 22.3856V4.46374C0.158634 3.65786 0.478777 2.88499 1.04863 2.31515C1.61849 1.74531 2.39138 1.42517 3.19729 1.42517H3.03908C2.64 1.42512 2.24482 1.50367 1.8761 1.65635C1.50739 1.80902 1.17236 2.03284 0.89015 2.315C0.607941 2.59716 0.384077 2.93215 0.231344 3.30083C0.0786111 3.66952 -3.8879e-09 4.06468 0 4.46374L0 22.3856C0 23.1914 0.320143 23.9643 0.89 24.5342C1.45986 25.104 2.23275 25.4241 3.03865 25.4241H3.19686C2.39103 25.424 1.61825 25.1038 1.04848 24.534C0.478719 23.9642 0.158634 23.1914 0.158634 22.3856Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9613 1.42517H3.03908C2.64 1.42512 2.24482 1.50367 1.8761 1.65635C1.50739 1.80902 1.17236 2.03284 0.89015 2.315C0.607941 2.59716 0.384077 2.93215 0.231344 3.30083C0.0786111 3.66952 -3.8879e-09 4.06468 0 4.46374L0 8.02232H24V4.46374C24.0001 4.0647 23.9215 3.66955 23.7688 3.30087C23.6161 2.93218 23.3923 2.59719 23.1101 2.31502C22.8279 2.03286 22.4929 1.80904 22.1243 1.65636C21.7556 1.50367 21.3604 1.42512 20.9613 1.42517Z",
    fill: "#F74343"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 1.42517H20.8027C21.2018 1.42512 21.597 1.50367 21.9656 1.65636C22.3343 1.80904 22.6693 2.03286 22.9515 2.31502C23.2337 2.59719 23.4575 2.93218 23.6102 3.30087C23.7629 3.66955 23.8414 4.0647 23.8414 4.46374V8.02232H23.9996V4.46374C23.9997 4.0647 23.9211 3.66955 23.7684 3.30087C23.6157 2.93218 23.3919 2.59719 23.1097 2.31502C22.8275 2.03286 22.4925 1.80904 22.1239 1.65636C21.7552 1.50367 21.36 1.42512 20.9609 1.42517Z",
    fill: "#DB3131"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.158634 4.66564C0.159084 3.86001 0.479412 3.08753 1.04921 2.51799C1.61901 1.94845 2.39164 1.62845 3.19729 1.62834H21.1196C21.5607 1.62798 21.9965 1.72389 22.3968 1.90938C22.797 2.09487 23.1519 2.36546 23.4367 2.70227C23.1561 2.30719 22.7849 1.98506 22.3543 1.76287C21.9236 1.54068 21.446 1.42488 20.9613 1.42517H3.03908C2.64 1.42512 2.24482 1.50367 1.8761 1.65635C1.50739 1.80903 1.17236 2.03284 0.89015 2.315C0.607941 2.59716 0.384077 2.93215 0.231344 3.30084C0.0786111 3.66952 -3.8879e-09 4.06468 0 4.46374L0 8.02232H0.158634V4.66564Z",
    fill: "#F74343"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 8.02216H0V8.22575H23.9996V8.02216Z",
    fill: "#DB3131"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2051 25.4244V22.3888C18.205 21.9897 18.2835 21.5944 18.4361 21.2256C18.5888 20.8569 18.8126 20.5218 19.0948 20.2395C19.3769 19.9572 19.7119 19.7333 20.0807 19.5805C20.4494 19.4277 20.8446 19.349 21.2437 19.3489H24.0007L18.2051 25.4244Z",
    fill: "url(#paint4_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98162 3.39018C5.29932 3.07248 5.29932 2.5574 4.98162 2.2397C4.66391 1.92201 4.14882 1.92201 3.83111 2.2397C3.51341 2.5574 3.51341 3.07248 3.83111 3.39018C4.14882 3.70787 4.66391 3.70787 4.98162 3.39018Z",
    fill: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4066 2.00109C4.61713 2.00118 4.81941 2.08291 4.97091 2.2291C5.1224 2.37529 5.21128 2.57453 5.21886 2.78491C5.21886 2.77516 5.21886 2.7654 5.21886 2.75565C5.21886 2.53989 5.13315 2.33297 4.98058 2.18041C4.82801 2.02785 4.62109 1.94214 4.40533 1.94214C4.18957 1.94214 3.98264 2.02785 3.83007 2.18041C3.67751 2.33297 3.5918 2.53989 3.5918 2.75565C3.5918 2.7654 3.5918 2.77516 3.5918 2.78491C3.59939 2.57409 3.68863 2.37447 3.84067 2.22821C3.9927 2.08196 4.19563 2.00052 4.4066 2.00109Z",
    fill: "#F74343"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40728 3.6281C4.2015 3.62796 4.00343 3.54979 3.853 3.40937C3.70258 3.26894 3.611 3.07671 3.59672 2.87143C3.59672 2.89009 3.59375 2.90875 3.59375 2.92784C3.59375 3.1436 3.67946 3.35052 3.83203 3.50308C3.98459 3.65564 4.19152 3.74135 4.40728 3.74135C4.62304 3.74135 4.82997 3.65564 4.98253 3.50308C5.1351 3.35052 5.22081 3.1436 5.22081 2.92784C5.22081 2.90875 5.22081 2.89009 5.21827 2.87143C5.20398 3.07678 5.11234 3.26908 4.96183 3.40951C4.81131 3.54994 4.61314 3.62806 4.40728 3.6281Z",
    fill: "#F74343"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93044 3.17958C9.13196 2.77802 8.9698 2.28912 8.56823 2.0876C8.16666 1.88608 7.67776 2.04824 7.47623 2.44979C7.2747 2.85135 7.43686 3.34025 7.83843 3.54177C8.24 3.74329 8.72891 3.58113 8.93044 3.17958Z",
    fill: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20348 2.00109C8.414 2.00118 8.61629 2.08291 8.76778 2.2291C8.91927 2.37529 9.00816 2.57453 9.01573 2.78491C9.01573 2.77516 9.01573 2.7654 9.01573 2.75565C9.01573 2.53989 8.93002 2.33297 8.77746 2.18041C8.62489 2.02785 8.41796 1.94214 8.2022 1.94214C7.98644 1.94214 7.77952 2.02785 7.62695 2.18041C7.47438 2.33297 7.38867 2.53989 7.38867 2.75565C7.38867 2.7654 7.38867 2.77516 7.38867 2.78491C7.39626 2.57409 7.4855 2.37447 7.63754 2.22821C7.78958 2.08196 7.99251 2.00052 8.20348 2.00109Z",
    fill: "#F74343"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20416 3.6281C7.99837 3.62796 7.8003 3.54979 7.64988 3.40937C7.49945 3.26894 7.40787 3.07671 7.39359 2.87143C7.39359 2.89009 7.39063 2.90875 7.39063 2.92784C7.39062 3.1436 7.47634 3.35052 7.6289 3.50308C7.78147 3.65564 7.98839 3.74135 8.20416 3.74135C8.41992 3.74135 8.62684 3.65564 8.77941 3.50308C8.93198 3.35052 9.01769 3.1436 9.01769 2.92784C9.01769 2.90875 9.01769 2.89009 9.01514 2.87143C9.00086 3.07678 8.90922 3.26908 8.7587 3.40951C8.60819 3.54994 8.41001 3.62806 8.20416 3.6281Z",
    fill: "#F74343"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 3.12581C12.922 2.71072 12.7249 2.23484 12.3098 2.06291C11.8947 1.89097 11.4188 2.08809 11.2469 2.50317C11.0749 2.91826 11.2721 3.39414 11.6872 3.56608C12.1023 3.73801 12.5781 3.5409 12.7501 3.12581Z",
    fill: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 2.00109C12.2109 2.00118 12.4132 2.08291 12.5647 2.2291C12.7161 2.37529 12.805 2.57453 12.8126 2.78491C12.8126 2.77516 12.8126 2.7654 12.8126 2.75565C12.8126 2.53989 12.7269 2.33297 12.5743 2.18041C12.4218 2.02785 12.2148 1.94214 11.9991 1.94214C11.7833 1.94214 11.5764 2.02785 11.4238 2.18041C11.2713 2.33297 11.1855 2.53989 11.1855 2.75565C11.1855 2.7654 11.1855 2.77516 11.1855 2.78491C11.193 2.57405 11.2822 2.37437 11.4343 2.22809C11.5864 2.08182 11.7894 2.00041 12.0004 2.00109Z",
    fill: "#F74343"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 3.6281C11.7952 3.62806 11.5971 3.54992 11.4466 3.40948C11.2962 3.26904 11.2046 3.07675 11.1905 2.87143C11.1905 2.89009 11.1875 2.90875 11.1875 2.92784C11.1875 3.1436 11.2732 3.35052 11.4258 3.50308C11.5783 3.65564 11.7853 3.74135 12.001 3.74135C12.2168 3.74135 12.4237 3.65564 12.5763 3.50308C12.7289 3.35052 12.8146 3.1436 12.8146 2.92784C12.8146 2.90875 12.8146 2.89009 12.8116 2.87143C12.7974 3.07675 12.7059 3.26904 12.5554 3.40948C12.405 3.54992 12.2068 3.62806 12.001 3.6281Z",
    fill: "#F74343"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9839 3.60685C16.4212 3.50364 16.692 3.06549 16.5888 2.62822C16.4856 2.19094 16.0474 1.92013 15.6101 2.02333C15.1728 2.12654 14.902 2.56469 15.0052 3.00196C15.1084 3.43924 15.5466 3.71005 15.9839 3.60685Z",
    fill: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7972 2.00109C16.0077 2.00128 16.2099 2.08305 16.3614 2.22922C16.5129 2.37538 16.6018 2.57457 16.6095 2.78491C16.6095 2.77516 16.6095 2.7654 16.6095 2.75565C16.6095 2.53989 16.5238 2.33297 16.3712 2.18041C16.2186 2.02785 16.0117 1.94214 15.796 1.94214C15.5802 1.94214 15.3733 2.02785 15.2207 2.18041C15.0681 2.33297 14.9824 2.53989 14.9824 2.75565C14.9824 2.7654 14.9824 2.77516 14.9824 2.78491C14.9901 2.57413 15.0794 2.37457 15.2314 2.22833C15.3834 2.0821 15.5863 2.00062 15.7972 2.00109Z",
    fill: "#F74343"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7979 3.6281C15.5921 3.62806 15.394 3.54992 15.2435 3.40948C15.0931 3.26904 15.0015 3.07675 14.9873 2.87143C14.9873 2.89009 14.9844 2.90875 14.9844 2.92784C14.9844 3.1436 15.0701 3.35052 15.2227 3.50308C15.3752 3.65564 15.5821 3.74135 15.7979 3.74135C16.0137 3.74135 16.2206 3.65564 16.3732 3.50308C16.5257 3.35052 16.6114 3.1436 16.6114 2.92784C16.6114 2.90875 16.6114 2.89009 16.6085 2.87143C16.5943 3.07675 16.5027 3.26904 16.3523 3.40948C16.2018 3.54992 16.0037 3.62806 15.7979 3.6281Z",
    fill: "#F74343"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7808 3.60736C20.218 3.50416 20.4889 3.06601 20.3857 2.62874C20.2825 2.19146 19.8443 1.92065 19.407 2.02385C18.9697 2.12706 18.6989 2.56521 18.8021 3.00248C18.9053 3.43975 19.3435 3.71057 19.7808 3.60736Z",
    fill: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5926 2.00109C19.8031 2.00118 20.0053 2.08293 20.1567 2.22913C20.3081 2.37532 20.3969 2.57457 20.4044 2.78491C20.4044 2.77516 20.4044 2.7654 20.4044 2.75565C20.4044 2.53989 20.3187 2.33297 20.1661 2.18041C20.0136 2.02785 19.8066 1.94214 19.5909 1.94214C19.3751 1.94214 19.1682 2.02785 19.0156 2.18041C18.8631 2.33297 18.7773 2.53989 18.7773 2.75565C18.7773 2.7654 18.7773 2.77516 18.7773 2.78491C18.785 2.57405 18.8744 2.37443 19.0265 2.22818C19.1786 2.08194 19.3816 2.00051 19.5926 2.00109Z",
    fill: "#F74343"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5928 3.6281C19.387 3.62806 19.1889 3.54992 19.0384 3.40948C18.888 3.26904 18.7964 3.07675 18.7823 2.87143C18.7823 2.89009 18.7793 2.90875 18.7793 2.92784C18.7793 3.1436 18.865 3.35052 19.0176 3.50308C19.1701 3.65564 19.3771 3.74135 19.5928 3.74135C19.8086 3.74135 20.0155 3.65564 20.1681 3.50308C20.3206 3.35052 20.4064 3.1436 20.4064 2.92784C20.4064 2.90875 20.4064 2.89009 20.4034 2.87143C20.3892 3.07675 20.2977 3.26904 20.1472 3.40948C19.9968 3.54992 19.7986 3.62806 19.5928 3.6281Z",
    fill: "#F74343"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83542 0C4.7635 -8.77932e-08 4.69452 0.0285411 4.64362 0.0793566C4.59273 0.130172 4.56408 0.199108 4.56396 0.271029V2.54487C4.56674 2.61495 4.59653 2.68124 4.64709 2.72984C4.69766 2.77845 4.76507 2.80559 4.83521 2.80559C4.90535 2.80559 4.97277 2.77845 5.02333 2.72984C5.0739 2.68124 5.10369 2.61495 5.10646 2.54487V0.271029C5.10646 0.199147 5.0779 0.13021 5.02708 0.0793824C4.97625 0.0285547 4.90731 0 4.83542 0V0Z",
    fill: "#636363"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00077 0C3.92889 0 3.85995 0.0285547 3.80912 0.0793824C3.75829 0.13021 3.72974 0.199147 3.72974 0.271029V2.54487C3.73251 2.61495 3.7623 2.68124 3.81286 2.72984C3.86343 2.77845 3.93085 2.80559 4.00098 2.80559C4.07112 2.80559 4.13854 2.77845 4.1891 2.72984C4.23967 2.68124 4.26946 2.61495 4.27223 2.54487V0.271029C4.27212 0.199108 4.24347 0.130172 4.19257 0.0793566C4.14168 0.0285411 4.07269 -8.77932e-08 4.00077 0V0Z",
    fill: "#636363"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63401 3.31912e-07C8.59838 -5.54235e-05 8.56309 0.00691379 8.53016 0.0205093C8.49723 0.0341048 8.4673 0.0540598 8.44208 0.0792326C8.41687 0.104406 8.39687 0.134302 8.38322 0.167213C8.36957 0.200123 8.36255 0.235401 8.36255 0.271029V2.54487C8.36532 2.61495 8.39511 2.68124 8.44568 2.72984C8.49624 2.77845 8.56366 2.80559 8.6338 2.80559C8.70393 2.80559 8.77135 2.77845 8.82192 2.72984C8.87248 2.68124 8.90227 2.61495 8.90504 2.54487V0.271029C8.90504 0.199148 8.87649 0.13021 8.82566 0.0793827C8.77483 0.028555 8.70589 3.31912e-07 8.63401 3.31912e-07Z",
    fill: "#636363"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7974 0C7.72552 0 7.65658 0.0285547 7.60575 0.0793824C7.55492 0.13021 7.52637 0.199147 7.52637 0.271029V2.54487C7.52914 2.61495 7.55893 2.68124 7.6095 2.72984C7.66006 2.77845 7.72748 2.80559 7.79761 2.80559C7.86775 2.80559 7.93517 2.77845 7.98573 2.72984C8.0363 2.68124 8.06609 2.61495 8.06886 2.54487V0.271029C8.06875 0.199108 8.0401 0.130172 7.9892 0.0793566C7.93831 0.0285411 7.86933 -8.77932e-08 7.7974 0V0Z",
    fill: "#636363"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4263 3.31912e-07C12.3544 3.31912e-07 12.2855 0.028555 12.2347 0.0793827C12.1838 0.13021 12.1553 0.199148 12.1553 0.271029V2.54487C12.158 2.61495 12.1878 2.68124 12.2384 2.72984C12.289 2.77845 12.3564 2.80559 12.4265 2.80559C12.4967 2.80559 12.5641 2.77845 12.6146 2.72984C12.6652 2.68124 12.695 2.61495 12.6978 2.54487V0.271029C12.6978 0.235401 12.6907 0.200123 12.6771 0.167213C12.6634 0.134302 12.6434 0.104406 12.6182 0.0792326C12.593 0.0540598 12.5631 0.0341048 12.5302 0.0205093C12.4972 0.00691379 12.4619 -5.54235e-05 12.4263 3.31912e-07Z",
    fill: "#636363"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.594 0C11.5221 0 11.4532 0.0285547 11.4024 0.0793824C11.3516 0.13021 11.323 0.199147 11.323 0.271029V2.54487C11.323 2.61675 11.3516 2.68569 11.4024 2.73651C11.4532 2.78734 11.5221 2.8159 11.594 2.8159C11.6659 2.8159 11.7349 2.78734 11.7857 2.73651C11.8365 2.68569 11.8651 2.61675 11.8651 2.54487V0.271029C11.8651 0.199147 11.8365 0.13021 11.7857 0.0793824C11.7349 0.0285547 11.6659 0 11.594 0V0Z",
    fill: "#636363"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2249 8.28738e-06C16.153 8.28738e-06 16.0841 0.028563 16.0332 0.0793907C15.9824 0.130218 15.9539 0.199156 15.9539 0.271037V2.54488C15.9539 2.6171 15.9825 2.68636 16.0336 2.73742C16.0847 2.78849 16.1539 2.81718 16.2262 2.81718C16.2984 2.81718 16.3676 2.78849 16.4187 2.73742C16.4698 2.68636 16.4985 2.6171 16.4985 2.54488V0.271037C16.4984 0.235246 16.4913 0.199819 16.4775 0.166795C16.4637 0.133771 16.4435 0.103801 16.4181 0.0786118C16.3926 0.0534222 16.3625 0.0335094 16.3293 0.0200194C16.2962 0.00652947 16.2607 -0.000271373 16.2249 8.28738e-06Z",
    fill: "#636363"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3907 0C15.3188 0 15.2498 0.0285547 15.199 0.0793824C15.1482 0.13021 15.1196 0.199147 15.1196 0.271029V2.54487C15.1196 2.61675 15.1482 2.68569 15.199 2.73651C15.2498 2.78734 15.3188 2.8159 15.3907 2.8159C15.4625 2.8159 15.5315 2.78734 15.5823 2.73651C15.6331 2.68569 15.6617 2.61675 15.6617 2.54487V0.271029C15.6617 0.199147 15.6331 0.13021 15.5823 0.0793824C15.5315 0.0285547 15.4625 0 15.3907 0V0Z",
    fill: "#636363"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0237 0C19.9518 0 19.8829 0.0285547 19.8321 0.0793824C19.7812 0.13021 19.7527 0.199147 19.7527 0.271029V2.54487C19.7555 2.61495 19.7852 2.68124 19.8358 2.72984C19.8864 2.77845 19.9538 2.80559 20.0239 2.80559C20.0941 2.80559 20.1615 2.77845 20.2121 2.72984C20.2626 2.68124 20.2924 2.61495 20.2952 2.54487V0.271029C20.2951 0.199108 20.2664 0.130172 20.2155 0.0793566C20.1646 0.0285411 20.0956 -8.77932e-08 20.0237 0V0Z",
    fill: "#636363"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1856 5.31061e-06C19.114 0.000453437 19.0455 0.0292058 18.995 0.0799851C18.9446 0.130764 18.9163 0.199446 18.9163 0.271034V2.54487C18.9163 2.58047 18.9233 2.61571 18.9369 2.64859C18.9505 2.68147 18.9705 2.71135 18.9956 2.73652C19.0208 2.76169 19.0507 2.78165 19.0836 2.79527C19.1165 2.80889 19.1517 2.8159 19.1873 2.8159C19.2229 2.8159 19.2581 2.80889 19.291 2.79527C19.3239 2.78165 19.3538 2.76169 19.3789 2.73652C19.4041 2.71135 19.4241 2.68147 19.4377 2.64859C19.4513 2.61571 19.4583 2.58047 19.4583 2.54487V0.271034C19.4583 0.235299 19.4513 0.199916 19.4375 0.166922C19.4238 0.133929 19.4037 0.103975 19.3783 0.0787854C19.353 0.0535958 19.3229 0.0336674 19.2898 0.0201471C19.2568 0.00662687 19.2213 -0.000218384 19.1856 5.31061e-06Z",
    fill: "#636363"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83542 0C4.7635 -8.77932e-08 4.69452 0.0285411 4.64362 0.0793566C4.59273 0.130172 4.56408 0.199108 4.56396 0.271029V0.424145C4.56674 0.354063 4.59653 0.287775 4.64709 0.239171C4.69766 0.190567 4.76507 0.16342 4.83521 0.16342C4.90535 0.16342 4.97277 0.190567 5.02333 0.239171C5.0739 0.287775 5.10369 0.354063 5.10646 0.424145V0.271029C5.10646 0.199147 5.0779 0.13021 5.02708 0.0793824C4.97625 0.0285547 4.90731 0 4.83542 0V0Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83591 2.65393C4.76392 2.65393 4.69487 2.62533 4.64396 2.57442C4.59305 2.52352 4.56445 2.45447 4.56445 2.38248V2.54492C4.56723 2.61501 4.59702 2.68129 4.64758 2.7299C4.69815 2.7785 4.76556 2.80565 4.8357 2.80565C4.90584 2.80565 4.97325 2.7785 5.02382 2.7299C5.07439 2.68129 5.10418 2.61501 5.10695 2.54492V2.38375C5.10672 2.45548 5.07807 2.5242 5.02726 2.57485C4.97646 2.62549 4.90765 2.65393 4.83591 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00077 0C3.92889 0 3.85995 0.0285547 3.80912 0.0793824C3.75829 0.13021 3.72974 0.199147 3.72974 0.271029V0.424145C3.73251 0.354063 3.7623 0.287775 3.81286 0.239171C3.86343 0.190567 3.93085 0.16342 4.00098 0.16342C4.07112 0.16342 4.13854 0.190567 4.1891 0.239171C4.23967 0.287775 4.26946 0.354063 4.27223 0.424145V0.271029C4.27212 0.199108 4.24347 0.130172 4.19257 0.0793566C4.14168 0.0285411 4.07269 -8.77932e-08 4.00077 0V0Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0015 2.65393C3.96588 2.65393 3.9306 2.64691 3.89769 2.63326C3.86477 2.61961 3.83488 2.59961 3.8097 2.5744C3.78453 2.54918 3.76457 2.51926 3.75098 2.48633C3.73738 2.45339 3.73041 2.4181 3.73047 2.38248V2.54492C3.73324 2.61501 3.76303 2.68129 3.8136 2.7299C3.86416 2.7785 3.93158 2.80565 4.00172 2.80565C4.07185 2.80565 4.13927 2.7785 4.18984 2.7299C4.2404 2.68129 4.27019 2.61501 4.27296 2.54492V2.38375C4.27263 2.45552 4.24388 2.52424 4.19301 2.57487C4.14214 2.62551 4.07328 2.65393 4.0015 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63358 3.31912e-07C8.5617 3.31912e-07 8.49276 0.028555 8.44193 0.0793827C8.3911 0.13021 8.36255 0.199148 8.36255 0.271029V0.424145C8.36532 0.354064 8.39511 0.287775 8.44568 0.239171C8.49624 0.190567 8.56366 0.16342 8.6338 0.16342C8.70393 0.16342 8.77135 0.190567 8.82192 0.239171C8.87248 0.287775 8.90227 0.354064 8.90504 0.424145V0.271029C8.90504 0.235401 8.89802 0.200123 8.88437 0.167213C8.87073 0.134302 8.85072 0.104406 8.82551 0.0792326C8.8003 0.0540598 8.77037 0.0341048 8.73744 0.0205093C8.7045 0.00691379 8.66921 -5.54235e-05 8.63358 3.31912e-07Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63432 2.65393C8.59869 2.65393 8.56341 2.64691 8.5305 2.63326C8.49759 2.61961 8.46769 2.59961 8.44252 2.5744C8.41734 2.54918 8.39739 2.51926 8.38379 2.48633C8.3702 2.45339 8.36323 2.4181 8.36328 2.38248V2.54492C8.36605 2.61501 8.39584 2.68129 8.44641 2.7299C8.49697 2.7785 8.56439 2.80565 8.63453 2.80565C8.70467 2.80565 8.77208 2.7785 8.82265 2.7299C8.87321 2.68129 8.903 2.61501 8.90578 2.54492V2.38375C8.90555 2.45556 8.87684 2.52434 8.82594 2.575C8.77505 2.62565 8.70613 2.65404 8.63432 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7974 0C7.72552 0 7.65658 0.0285547 7.60575 0.0793824C7.55492 0.13021 7.52637 0.199147 7.52637 0.271029V0.424145C7.52914 0.354063 7.55893 0.287775 7.6095 0.239171C7.66006 0.190567 7.72748 0.16342 7.79761 0.16342C7.86775 0.16342 7.93517 0.190567 7.98573 0.239171C8.0363 0.287775 8.06609 0.354063 8.06886 0.424145V0.271029C8.06875 0.199108 8.0401 0.130172 7.9892 0.0793566C7.93831 0.0285411 7.86933 -8.77932e-08 7.7974 0V0Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79643 2.65393C7.7608 2.65393 7.72552 2.64691 7.69261 2.63326C7.6597 2.61961 7.6298 2.59961 7.60463 2.5744C7.57945 2.54918 7.5595 2.51926 7.5459 2.48633C7.53231 2.45339 7.52534 2.4181 7.52539 2.38248V2.54492C7.52816 2.61501 7.55795 2.68129 7.60852 2.7299C7.65908 2.7785 7.7265 2.80565 7.79664 2.80565C7.86678 2.80565 7.93419 2.7785 7.98476 2.7299C8.03532 2.68129 8.06511 2.61501 8.06789 2.54492V2.38375C8.06755 2.45552 8.0388 2.52424 7.98793 2.57487C7.93706 2.62551 7.8682 2.65393 7.79643 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4263 3.31912e-07C12.3544 3.31912e-07 12.2855 0.028555 12.2347 0.0793827C12.1838 0.13021 12.1553 0.199148 12.1553 0.271029V0.424145C12.158 0.354064 12.1878 0.287775 12.2384 0.239171C12.289 0.190567 12.3564 0.16342 12.4265 0.16342C12.4967 0.16342 12.5641 0.190567 12.6146 0.239171C12.6652 0.287775 12.695 0.354064 12.6978 0.424145V0.271029C12.6978 0.235401 12.6907 0.200123 12.6771 0.167213C12.6634 0.134302 12.6434 0.104406 12.6182 0.0792326C12.593 0.0540598 12.5631 0.0341048 12.5302 0.0205093C12.4972 0.00691379 12.4619 -5.54235e-05 12.4263 3.31912e-07Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4273 2.65393C12.3917 2.65393 12.3564 2.64691 12.3235 2.63326C12.2906 2.61961 12.2607 2.59961 12.2355 2.5744C12.2103 2.54918 12.1904 2.51926 12.1768 2.48633C12.1632 2.45339 12.1562 2.4181 12.1563 2.38248V2.54492C12.159 2.61501 12.1888 2.68129 12.2394 2.7299C12.2899 2.7785 12.3574 2.80565 12.4275 2.80565C12.4976 2.80565 12.5651 2.7785 12.6156 2.7299C12.6662 2.68129 12.696 2.61501 12.6987 2.54492V2.38375C12.6985 2.45556 12.6698 2.52434 12.6189 2.575C12.568 2.62565 12.4991 2.65404 12.4273 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.594 0C11.5221 0 11.4532 0.0285547 11.4024 0.0793824C11.3516 0.13021 11.323 0.199147 11.323 0.271029V0.424145C11.323 0.352264 11.3516 0.283326 11.4024 0.232499C11.4532 0.181671 11.5221 0.153116 11.594 0.153116C11.6659 0.153116 11.7349 0.181671 11.7857 0.232499C11.8365 0.283326 11.8651 0.352264 11.8651 0.424145V0.271029C11.8651 0.199147 11.8365 0.13021 11.7857 0.0793824C11.7349 0.0285547 11.6659 0 11.594 0V0Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5933 2.65393C11.5577 2.65393 11.5224 2.64691 11.4895 2.63326C11.4566 2.61961 11.4267 2.59961 11.4015 2.5744C11.3763 2.54918 11.3564 2.51926 11.3428 2.48633C11.3292 2.45339 11.3222 2.4181 11.3223 2.38248V2.54492C11.3223 2.61681 11.3508 2.68574 11.4017 2.73657C11.4525 2.7874 11.5214 2.81595 11.5933 2.81595C11.6652 2.81595 11.7341 2.7874 11.785 2.73657C11.8358 2.68574 11.8643 2.61681 11.8643 2.54492V2.38375C11.8641 2.45548 11.8355 2.5242 11.7847 2.57485C11.7338 2.62549 11.665 2.65393 11.5933 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2249 8.28738e-06C16.153 8.28738e-06 16.0841 0.028563 16.0332 0.0793907C15.9824 0.130218 15.9539 0.199156 15.9539 0.271037V0.424153C15.9539 0.351934 15.9825 0.282674 16.0336 0.231607C16.0847 0.180541 16.1539 0.151852 16.2262 0.151852C16.2984 0.151852 16.3676 0.180541 16.4187 0.231607C16.4698 0.282674 16.4985 0.351934 16.4985 0.424153V0.271037C16.4984 0.235246 16.4913 0.199819 16.4775 0.166795C16.4637 0.133771 16.4435 0.103801 16.4181 0.0786118C16.3926 0.0534222 16.3625 0.0335094 16.3293 0.0200194C16.2962 0.00652947 16.2607 -0.000271373 16.2249 8.28738e-06Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2242 2.65393C16.1885 2.65393 16.1533 2.64691 16.1203 2.63326C16.0874 2.61961 16.0575 2.59961 16.0324 2.5744C16.0072 2.54918 15.9872 2.51926 15.9736 2.48633C15.96 2.45339 15.9531 2.4181 15.9531 2.38248V2.54492C15.9531 2.61714 15.9818 2.6864 16.0329 2.73747C16.0839 2.78854 16.1532 2.81723 16.2254 2.81723C16.2977 2.81723 16.3669 2.78854 16.418 2.73747C16.4691 2.6864 16.4977 2.61714 16.4977 2.54492V2.38375C16.4976 2.41947 16.4904 2.4548 16.4765 2.48773C16.4627 2.52066 16.4424 2.55053 16.417 2.57563C16.3916 2.60072 16.3615 2.62056 16.3284 2.634C16.2953 2.64744 16.2599 2.65421 16.2242 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3907 0C15.3188 0 15.2498 0.0285547 15.199 0.0793824C15.1482 0.13021 15.1196 0.199147 15.1196 0.271029V0.424145C15.1196 0.352264 15.1482 0.283326 15.199 0.232499C15.2498 0.181671 15.3188 0.153116 15.3907 0.153116C15.4625 0.153116 15.5315 0.181671 15.5823 0.232499C15.6331 0.283326 15.6617 0.352264 15.6617 0.424145V0.271029C15.6617 0.199147 15.6331 0.13021 15.5823 0.0793824C15.5315 0.0285547 15.4625 0 15.3907 0V0Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3902 2.65393C15.3545 2.65393 15.3193 2.64691 15.2864 2.63326C15.2534 2.61961 15.2235 2.59961 15.1984 2.5744C15.1732 2.54918 15.1532 2.51926 15.1396 2.48633C15.1261 2.45339 15.1191 2.4181 15.1191 2.38248V2.54492C15.1191 2.61681 15.1477 2.68574 15.1985 2.73657C15.2494 2.7874 15.3183 2.81595 15.3902 2.81595C15.4621 2.81595 15.531 2.7874 15.5818 2.73657C15.6327 2.68574 15.6612 2.61681 15.6612 2.54492V2.38375C15.661 2.45548 15.6323 2.5242 15.5815 2.57485C15.5307 2.62549 15.4619 2.65393 15.3902 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1856 8.29786e-06C19.114 0.000567232 19.0456 0.0293551 18.9952 0.0801103C18.9447 0.130865 18.9164 0.199482 18.9163 0.271037V0.424153C18.919 0.354072 18.9488 0.287783 18.9994 0.239179C19.05 0.190575 19.1174 0.163428 19.1875 0.163428C19.2576 0.163428 19.3251 0.190575 19.3756 0.239179C19.4262 0.287783 19.456 0.354072 19.4588 0.424153V0.271037C19.4588 0.235266 19.4517 0.199848 19.4379 0.166827C19.4242 0.133805 19.404 0.103832 19.3786 0.078637C19.3532 0.0534418 19.3231 0.0335223 19.29 0.0200272C19.2568 0.00653215 19.2214 -0.000271601 19.1856 8.29786e-06Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1855 2.65393C19.1135 2.65393 19.0445 2.62533 18.9936 2.57442C18.9427 2.52352 18.9141 2.45447 18.9141 2.38248V2.54492C18.9168 2.61501 18.9466 2.68129 18.9972 2.7299C19.0478 2.7785 19.1152 2.80565 19.1853 2.80565C19.2554 2.80565 19.3229 2.7785 19.3734 2.7299C19.424 2.68129 19.4538 2.61501 19.4566 2.54492V2.38375C19.4563 2.45548 19.4277 2.5242 19.3769 2.57485C19.3261 2.62549 19.2573 2.65393 19.1855 2.65393Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0237 0C19.9518 0 19.8829 0.0285547 19.8321 0.0793824C19.7812 0.13021 19.7527 0.199147 19.7527 0.271029V0.424145C19.7527 0.352264 19.7812 0.283326 19.8321 0.232499C19.8829 0.181671 19.9518 0.153116 20.0237 0.153116C20.0956 0.153116 20.1645 0.181671 20.2154 0.232499C20.2662 0.283326 20.2948 0.352264 20.2948 0.424145V0.271029C20.2948 0.199147 20.2662 0.13021 20.2154 0.0793824C20.1645 0.0285547 20.0956 0 20.0237 0V0Z",
    fill: "#636363"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20.023 2.65393C19.9874 2.65393 19.9521 2.64691 19.9192 2.63326C19.8863 2.61961 19.8564 2.59961 19.8312 2.5744C19.806 2.54918 19.7861 2.51926 19.7725 2.48633C19.7589 2.45339 19.7519 2.4181 19.752 2.38248V2.54492C19.752 2.61681 19.7805 2.68574 19.8313 2.73657C19.8822 2.7874 19.9511 2.81595 20.023 2.81595C20.0949 2.81595 20.1638 2.7874 20.2146 2.73657C20.2655 2.68574 20.294 2.61681 20.294 2.54492V2.38375C20.2938 2.45548 20.2651 2.5242 20.2143 2.57485C20.1635 2.62549 20.0947 2.65393 20.023 2.65393Z",
    fill: "#636363"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.1283,
    y1: 10.9514,
    x2: 11.1766,
    y2: 33.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C6CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B7BBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 25.1524,
    y1: 28.6006,
    x2: 18.2771,
    y2: 20.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C6CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C4C7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#BBBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ADB1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9A9C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 3.48995,
    y1: 23.1257,
    x2: 26.0214,
    y2: 29.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E3E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D5D6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1619.56,
    y1: 5600.5,
    x2: 2381.62,
    y2: 5603.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E3E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D5D6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 2248.9,
    y1: 2676.51,
    x2: 3467.5,
    y2: 3610.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E3E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D5D6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8fbbd0ff775ebf0020e3c9b4434259a5.svg";
export { ForwardRef as ReactComponent };